// Utils
import cn from '../../../../utils/cn';
// Styles
import styles from './PictureCell.module.css';
import commonStyles from '../TableCellCommon.module.css';

/**
 * Picture cell component for displaying images in table cells
 * @param {object} props
 * @param {string} [props.src] - Direct image source URL
 * @param {string} [props.alt] - Alt text for the image
 * @param {'round' | 'original'} [props.shape='round'] - Shape of the image
 * @param {string} [props.className] - Additional CSS classes
 * @param {Align} [props.align='center'] - Alignment
 * @param {VerticalAlign} [props.verticalAlign='middle'] - Vertical alignment
 * @returns {JSX.Element}
 */
function PictureCell({
  src,
  alt,
  shape = 'original',
  className = '',
  align = 'left',
  verticalAlign = 'middle',
}) {
  return (
    <div
      className={cn([
        styles['picture-cell'],
        className,
        commonStyles[`cell-align-${align}`],
        verticalAlign && commonStyles[`cell-vertical-align-${verticalAlign}`],
      ])}
    >
      <div className={`${styles['picture-cell-container']} ${styles[`picture-cell-${shape}`]}`}>
        {src ? (
          <img
            src={src}
            alt={alt}
            className={`${styles['picture-cell-image']} ${styles[`picture-cell-placeholder-${shape}`]} ${styles[`picture-cell-image-${shape}`]}`}
          />
        ) : null}
      </div>
    </div>
  );
}

export default PictureCell;
